export default __webpack_public_path__ + "static/media/img11.fcb87a2f.png";